import request from "@/utils/request";
import axios from "@/utils/request";
import type { QueryParams, UserItem, PageResult } from "@/user/type";

// 统一的响应接口
export interface ApiResponse<T = any> {
  code: number;
  msg: string | null;
  data: T;
}

// 登录参数接口
export interface LoginParams {
  name: string;
  password: string;
}

// 登录响应数据接口
export interface LoginData {
  id: string;
  openid: string | null;
  token: string;
}

////// 响应数据类型
export interface UserListResponse {
  code: number;
  data: {
    record: UserItem[];
    total: number;
  };
  msg?: string;
}

// 登录接口
export function login(data: LoginParams): Promise<ApiResponse<LoginData>> {
  return request({
    url: "/admin/admin/login",
    method: "post",
    data,
  });
}

// 获取术语列表
export function getUserList(query: QueryParams) {
  return request<ApiResponse<PageResult<UserItem>>>({
    url: "/admin/user/userList",
    method: "get",
    params: query,
  });
}

// 更新用户类型 - 修改函数签名，接收 id 和 userType
export function updateUserType(id: string, userType?: number) {
  return request({
    url: `/admin/user/${id}`, // 使用模板字符串拼接 id
    method: "put",
    params: {
      userType, // 将 userType 作为 Query 参数传递
    },
  });
}
